import React from 'react'
import { useAppSelector } from '../../../../store/hooks'
import {
  selectCrossClientLandingPollableExecutions,
  selectCrossClientLandingQueuedExecutions,
  selectCrossClientLandingRunningExecutionsLoading,
} from '../../../../store/crossClient/crossClientLanding'
import { CrossClientLandingHistory } from '../History/CrossClientLandingHistory'
import { CrossClientLandingQueued } from '../Queued/CrossClientLandingQueued'
import { CrossClientRowSkeleton } from '../CrossClientRowSkeleton'
import { CrossClientEmptyState } from '../CrossClientEmptyState'
import '../Tabs/CrossClientLandingTabs.scss'

export const CrossClientRunning: React.FC = () => {
  const pollableExecutions = useAppSelector(selectCrossClientLandingPollableExecutions)
  const queuedExecutions = useAppSelector(selectCrossClientLandingQueuedExecutions)
  const loading = useAppSelector(selectCrossClientLandingRunningExecutionsLoading)

  const isEmpty = !pollableExecutions.length && !queuedExecutions.length

  if (isEmpty && loading) {
    return <CrossClientRowSkeleton count={2} />
  }

  if (isEmpty) {
    return <CrossClientEmptyState message='No running queries' />
  }

  return (
    <div className='d-flex flex-column gap-2 w-100'>
      {pollableExecutions.length ? <CrossClientLandingHistory /> : null}
      {queuedExecutions.length ? (
        <>
          <div className='d-flex gap-2 align-items-center w-100 cross-client-tabs-divider'>
            <div className='flex-grow-1 cross-client-tabs-divider-line' />
            <div className='d-flex gap-1 align-items-center paragraph-small zocks-text-gray-700'>
              <i className='bi bi-clock' />
              <span>Following queries are waiting in the queue to start</span>
            </div>
            <div className='flex-grow-1 cross-client-tabs-divider-line' />
          </div>
          <CrossClientLandingQueued />
        </>
      ) : null}
    </div>
  )
}
